import { motion } from 'framer-motion';

const services = [
  {
    icon: 'ri-layout-masonry-line',
    title: 'Neue Webseite für Freiburg',
    description:
      'Maßgeschneiderte Webseiten für Freiburger Unternehmen – kein Baukasten, kein Template. Individuell entwickelt, damit Ihre Marke in Freiburg heraussticht.',
    highlights: ['Einzigartiges Design', 'Responsive für alle Geräte', 'Conversion-optimiert'],
  },
  {
    icon: 'ri-robot-2-line',
    title: 'AI Chatbot Integration',
    description:
      'Intelligente Chatbots, die rund um die Uhr Kundenanfragen aus Freiburg und Umgebung beantworten – automatisiert und professionell.',
    highlights: ['24/7 Kundensupport', 'Automatische Terminbuchung', 'Lead-Generierung'],
  },
  {
    icon: 'ri-seo-line',
    title: 'SEO Freiburg',
    description:
      'Werden Sie bei Google in Freiburg gefunden. Lokale Suchmaschinenoptimierung, die Ihre Sichtbarkeit in der Region nachhaltig steigert.',
    highlights: ['Lokale SEO Freiburg', 'Google Maps Optimierung', 'Mehr organischer Traffic'],
  },
  {
    icon: 'ri-refresh-line',
    title: 'Webseiten Redesign',
    description:
      'Ihre bestehende Webseite wirkt veraltet? Ich verwandle sie in eine moderne, schnelle und verkaufsstarke Präsenz für den Freiburger Markt.',
    highlights: ['Modernes Design 2025', 'Bessere Nutzererfahrung', 'Höhere Conversion-Rate'],
  },
  {
    icon: 'ri-speed-line',
    title: 'Performance-Optimierung',
    description:
      'Ladezeiten unter 2 Sekunden – für bessere Google-Rankings und zufriedene Besucher. Technische Exzellenz für Ihren Freiburger Webauftritt.',
    highlights: ['Core Web Vitals', 'Unter 2 Sek. Ladezeit', 'Bessere Rankings'],
  },
  {
    icon: 'ri-shield-check-line',
    title: 'DSGVO & Sicherheit',
    description:
      'Vollständige DSGVO-Konformität, SSL-Zertifikat und Datenschutzerklärung – rechtssicher für Ihr Unternehmen in Freiburg.',
    highlights: ['DSGVO-konform', 'SSL-Zertifikat', 'Cookie-Management'],
  },
];

export default function FreiburgServices() {
  return (
    <section id="leistungen" className="py-20 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="inline-block bg-brand-green/10 text-brand-green text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-wider">
            Leistungen in Freiburg
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-caprasimo text-brand-black mb-4">
            Alles aus einer Hand
          </h2>
          <p className="text-lg text-brand-grey max-w-2xl mx-auto">
            Von der neuen Webseite bis zur AI-Automatisierung – professionelles Webdesign für Freiburger Unternehmen.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
              viewport={{ once: true }}
              className="group bg-brand-beige-light rounded-2xl p-7 hover:bg-white border-2 border-transparent hover:border-brand-green transition-all hover:shadow-xl relative overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-28 h-28 bg-gradient-to-br from-brand-green/10 to-transparent rounded-bl-full transform translate-x-6 -translate-y-6 group-hover:scale-150 transition-transform" />
              <div className="relative z-10">
                <div className="w-14 h-14 flex items-center justify-center bg-white rounded-xl mb-5 group-hover:bg-brand-green group-hover:scale-110 transition-all shadow-sm">
                  <i className={`${service.icon} text-2xl text-brand-green group-hover:text-white transition-colors`} />
                </div>
                <h3 className="text-lg font-caprasimo text-brand-black mb-3 group-hover:text-brand-green transition-colors">
                  {service.title}
                </h3>
                <p className="text-brand-grey text-sm leading-relaxed mb-5">{service.description}</p>
                <ul className="space-y-2">
                  {service.highlights.map((h, i) => (
                    <li key={i} className="flex items-center gap-2 text-sm text-brand-grey">
                      <div className="w-4 h-4 flex items-center justify-center bg-brand-green/10 rounded-full flex-shrink-0">
                        <i className="ri-check-line text-[10px] text-brand-green" />
                      </div>
                      {h}
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          viewport={{ once: true }}
          className="text-center mt-14"
        >
          <a
            href="#kontakt"
            className="inline-flex items-center gap-2 bg-brand-green hover:bg-brand-green-light text-white px-10 py-4 rounded-lg font-semibold text-base transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Jetzt kostenlos anfragen
            <i className="ri-arrow-right-line text-lg" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
